module.exports = __webpack_public_path__ + "./images/23ef9b34072e1f630dd849d7573298a2.webp";